export function parseExternalSkuFilter(sku) {
    const trimmed = sku.trim();
    if (!trimmed) {
        return null;
    }

    const parsed = Number(trimmed);
    if (!Number.isInteger(parsed) || parsed <= 0) {
        return null;
    }

    return parsed;
}

/**
 * Builds warehouse inventory v2 getPallets filter params for the bulk move modal.
 *
 * @param {{ externalSku?: string, locationId: string | number, lotId?: string | number, recipeCardsOnly?: boolean }} options
 * @returns {Array<{ searchBy: string, searchTerm: string | number }>}
 */
export function buildPalletFilters({ externalSku = '', locationId, lotId, recipeCardsOnly = false }) {
    const filters = [{ searchBy: 'locationId', searchTerm: locationId }];

    if (lotId) {
        filters.push({ searchBy: 'lotId', searchTerm: lotId });
    }

    const externalSkuFilter = parseExternalSkuFilter(externalSku);
    if (externalSkuFilter !== null) {
        filters.push({ searchBy: 'externalSku', searchTerm: externalSkuFilter });
        filters.push({ searchBy: 'type', searchTerm: 'ITEM' });
    }

    if (recipeCardsOnly) {
        filters.push({ searchBy: 'recipeCardsOnly', searchTerm: 'true' });
    }

    return filters;
}
